import { render, staticRenderFns } from "./Correlation.vue?vue&type=template&id=b0943ac4&scoped=true&"
import script from "./Correlation.vue?vue&type=script&lang=js&"
export * from "./Correlation.vue?vue&type=script&lang=js&"
import style0 from "./Correlation.vue?vue&type=style&index=0&id=b0943ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0943ac4",
  null
  
)

export default component.exports